import React, { useState } from "react";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import styles from "./Layout.module.css";

// const Layout = (Component: any) => ({ ...props }) => (
//     <div className={styles.layout}>
//         <Header />
//         <div className={styles.container}>
//             <Sidebar />
//             <div className={styles.mainContainer}>
//                 <Component {...props} />
//             </div>
//         </div>
//     </div>
// );

// export default Layout;
interface LayoutProps {
  Component: any;
  handleRecentQueries?: () => void;
}

const Layout = <P extends object>(Component: React.ComponentType<P>, options?: LayoutProps ) => {
    // This is the new component that will be returned by the HOC.
    // It's a proper React function component, so hooks can be called here.
    const WrappedComponent = (props: any) => {
        const [headerActions, setHeaderActions] = useState<React.ReactNode | null>(null);
        const [centerTitle, setCenterTitle] = useState<React.ReactNode | null>(null);
        const [isPanelOpen, setIsPanelOpen] = useState(false);
        const [isExpandedHeader, setIsExpandedHeader] = useState(false);
        const showRecentQueries = () => {
        // console.log('2. Layout received the call from Sidebar!'); // <-- ADD THIS
        setIsPanelOpen((prev) => !prev);
    };
        return (
            <div className={styles.layout}>
                <Header actions={headerActions} centerTitle={centerTitle}  handleRecentQueries={showRecentQueries} isExpandedHeader={isExpandedHeader} />
                <div className={styles.container}>
                    <Sidebar handleRecentQueries={showRecentQueries} isExpandedHeader={isExpandedHeader} />
                    <div className={styles.mainContainer}>
                        <Component 
                            {...props} 
                            setHeaderActions={setHeaderActions} 
                            setCenterTitle={setCenterTitle} 
                            isPanelOpen={isPanelOpen}      
                            togglePanel={showRecentQueries}
                            setIsExpandedHeader={setIsExpandedHeader}
                        />
                    </div>
                </div>
            </div>
        );
    };
    
    return WrappedComponent;
};


export default Layout;
